export enum EnvironmentType {
  LOCAL = 'local',
  DEVELOPMENT = 'development',
  UAT = 'uat',
  PRODUCTION = 'production',
}
